(function ($) { 
    $(document).on('click', '.expand_link', function (e) {
        e.preventDefault();
        $(this).parents().find('.expand_content').addClass('active');
        $(this).hide();
    });
    $(document).on('click', '.expand_link_back', function (e) {
        e.preventDefault();
        $(this).parents().removeClass('active');
        $('.expand_link').show();
    });
})(jQuery);